import { useState } from 'react';
import { Box, Flex, IconButton } from '@chakra-ui/react';
import { Delete, Edit } from '@material-ui/icons';

import { TableBase } from '@app/components/common/table/table-base';

import { SalesSource } from '../types';
import { SalesSourceDialog } from '../modals/sales-source';

export const SalesSourceTable = ({
  salesSources,
  outletSalesSources,
  isLoading,
  onAddSalesSource,
  onRemoveSalesSource,
  onUpdateSalesSource,
  readOnly = false,
}: {
  outlet_id: number;
  salesSources: EntityBase[];
  outletSalesSources: SalesSource[];
  isLoading: boolean;
  onAddSalesSource: (salesSource: SalesSource) => void;
  onRemoveSalesSource: (index: number) => void;
  onUpdateSalesSource: (index: number, salesSource: SalesSource) => void;
  readOnly?: boolean;
}) => {
  const [showSalesSourceForm, setShowSalesSourceForm] = useState(false);
  const [currentSalesSourceIndex, setCurrentSalesSourceIndex] = useState(-1);
  const onAddSalesSourceClick = () => {
    setShowSalesSourceForm(true);
    setCurrentSalesSourceIndex(-1);
  };

  const currentSalesSource = outletSalesSources[currentSalesSourceIndex];

  return (<Box mt={-5} marginX={-4}>
    <TableBase 
      title="Список источников продаж"
      onCreateClick={!readOnly && onAddSalesSourceClick}
      columns={[
        { label: 'Источник', name: 'source', options: { 
          sort: false, 
          filter: false,
          customBodyRender: (value) => {
            return (
              <Box whiteSpace='pre-wrap' style={{ wordBreak: 'break-all' }}>
                {value?.name.toString()}
              </Box>
            );
          },
        } },
        { label: 'ID ТТ источника продаж', name: 'sales_outlet_id',  options: { sort: false, filter: false } },
        { label: 'Действия', name: 'source',  options: { 
          sort: false,
          filter: false,
          customBodyRender: (_, { rowIndex }) => <Flex gap={2} alignItems='center'>
            {!readOnly && <IconButton aria-label="edit" onClick={() => {
              setShowSalesSourceForm(true);
              setCurrentSalesSourceIndex(rowIndex);
            }}
            >
              <Edit />
            </IconButton>}
            {!readOnly && <IconButton aria-label="delete" onClick={() => {
              onRemoveSalesSource(rowIndex);
            }}
            >
              <Delete />
            </IconButton>}
          </Flex>
          },
        },
      ]}
      data={outletSalesSources}
      loading={isLoading}
      paper={false}
      
    />
    <SalesSourceDialog
      isVisible={showSalesSourceForm}
      salesSources={salesSources}
      item={currentSalesSource}
      onClose={() => {
        setShowSalesSourceForm(false);
        setCurrentSalesSourceIndex(-1);
      }}
      onSave={async (item) => {
        if (currentSalesSourceIndex === -1) {
          onAddSalesSource(item);
        } else {
          onUpdateSalesSource(currentSalesSourceIndex, item);
        }
        setShowSalesSourceForm(false);
      }}
    />
  </Box>);
};